import ContentHeader from "../../components/content-header/ContentHeader";

import React, { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom";
import MaterialTable, { Column } from "@material-table/core";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import { useAuth, zeroPad } from "../../services/common/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getPaymentTransactinHistory } from "../../services/data-service/order-service";
import { toast } from "react-toastify";
// import { getAllPaymentTransactinHistory } from "../../services/data-service/order-service";
const TransactionHistory = () => {
    const navigate = useNavigate();
    const { userid, user, role, refid } = useAuth();
    const [transactionData, setTransactionData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
  
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
  
    const columns = [      
      { title: "Transaction Id", field: "transaction_id" },
      { title: "Dealer Name", field: "dealer_name" },
      { title: "Dealer Code", field: "dealer_code" },
      { title: "Amount", field: "amount" },
      { title: "Mode Of Transaction", field: "payment_gateway" },
      { title: "Transaction Date", field: "trans_date" },
      { title: "Txn Id", field: "txn_id" },      
    ];

    const formattedDate = (date)=>{
      const dateObj = new Date(date);
      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = dateObj.getFullYear();        
      const formattedDate = `${day}-${month}-${year}`;
      return formattedDate
    }
  
    function onSearch() {
      setTransactionData([]);
      setIsLoading(true);
  
      let fDate = `${fromDate.getFullYear()}-${
        fromDate.getMonth() + 1
      }-${fromDate.getDate()}`;
      let tDate = `${toDate.getFullYear()}-${
        toDate.getMonth() + 1
      }-${toDate.getDate()}`;  
      getPaymentTransactinHistory(fDate, tDate).then((response) => {
        if (response.status === 200) {
          if (response.data.length === 0){
            toast.error("No Records")
          }else {
            const formattedData = response.data.map(item => {
              return {
                ...item,
                trans_date: item?.trans_date ? formattedDate(item.trans_date) : '-'
              };
            });
            setTransactionData(formattedData);
          }
        }
      })
      .catch((err)=>{
        toast.error("Some eror occured")
      })  
      setIsLoading(false);
    }

    useEffect(()=>{
      async function fetchData(){
        setIsLoading(true);
        const currentDate = new Date().toISOString().split('T')[0]                
        await getPaymentTransactinHistory(currentDate, currentDate).then((response)=>{
          if (response.data.length === 0){
            toast.error("No Records")
          }else {
            const formattedData = response.data.map(item => {
              return {
                ...item,
                trans_date: item?.trans_date ? formattedDate(item.trans_date) : '-'
              };
            });
            setTransactionData(formattedData);
          }          
        })
        .catch((err)=>{
          toast.error("Some eror occured")
        })
        setIsLoading(false);
      }
      fetchData()      
    },[])


  return (
    <div>
      <ContentHeader title="Transaction History" />
        <section className="content">
          <div className="container-fluid">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-12">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>From Date &nbsp; </label>
                          <DatePicker
                            selected={fromDate}
                            onChange={(date) => setFromDate(date)}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={15}
                            showMonthDropdown
                            maxDate={new Date()}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label>To Date &nbsp;</label>
                          <DatePicker
                            selected={toDate}
                            onChange={(date) => setToDate(date)}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={15}
                            showMonthDropdown
                            maxDate={new Date()}
                          />
                        </div>
                      </div>
                      <div className="col-md-2">
                        <div className="form-group">
                          <button
                            type="button"
                            className="btn btn-lg btn-default"
                            onClick={() => onSearch()}
                          >
                            <i className="fa fa-search" /> Get Transaction Histoy
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <MaterialTable
                columns={columns}
                data={transactionData}
                isLoading={isLoading}
                title=""
                options={{
                  headerStyle: { fontWeight: "bold" },
                  pageSizeOptions: [5, 20, 50, 100],
                  exportAllData: true,
                  exportMenu: [
                    // {
                    //   label: "Export PDF",
                    //   exportFunc: (cols, datas) =>
                    //     ExportPdf(cols, datas, "oems"),
                    // },
                    {
                      label: "Export CSV",
                      exportFunc: (cols, datas) =>
                        ExportCsv(cols, datas, "Transaction History"),
                    },
                  ],
                }}
              />
            </div>
          </div>
        </section>
    </div>
  );
};

export default TransactionHistory;
